export interface FieldError {
  field: string
  message: string
}

export interface ErrorEnvelope {
  statusCode: number
  error: string
  message: string
  details?: FieldError[]
  requestId?: string
  timestamp: string
  path: string
}

export class ApiError extends Error {
  readonly statusCode: number
  readonly details: FieldError[]
  readonly requestId?: string

  constructor(envelope: ErrorEnvelope) {
    super(envelope.message)
    this.name = 'ApiError'
    this.statusCode = envelope.statusCode
    this.details = envelope.details ?? []
    this.requestId = envelope.requestId
  }

  /** Mensagem de um campo específico, para o React Hook Form. */
  fieldError(field: string): string | undefined {
    return this.details.find((detail) => detail.field === field)?.message
  }

  get isValidation(): boolean {
    return this.statusCode === 422
  }

  get isUnauthorized(): boolean {
    return this.statusCode === 401
  }

  get isNotFound(): boolean {
    return this.statusCode === 404
  }

  get isConflict(): boolean {
    return this.statusCode === 409
  }
}

/** Rede fora, DNS, CORS — tudo que impede a requisição de chegar. */
export class NetworkError extends Error {
  constructor() {
    super('Não foi possível conectar. Verifique sua internet.')
    this.name = 'NetworkError'
  }
}

export function messageOf(error: unknown): string {
  if (error instanceof ApiError || error instanceof NetworkError) return error.message
  if (error instanceof Error) return error.message
  return 'Algo deu errado. Tente novamente.'
}
